import React, { useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import HubSpotChat from "../../adaptive-homepage-hub/components/HubSpotChat";

const ConsultationCTA = () => {
  // Ensure HubSpot Meetings embed is available for inline scheduling
  useEffect(() => {
    if (!document.getElementById("MeetingsEmbedCode-js")) {
      const s = document.createElement("script");
      s.src =
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      s.async = true;
      s.defer = true;
      s.id = "MeetingsEmbedCode-js";
      document.body.appendChild(s);
    }
  }, []);

  const openHubSpotChat = () => {
    try {
      window.hsConversationsSettings = window.hsConversationsSettings || {
        loadImmediately: true,
      };
      if (window.HubSpotConversations && window.HubSpotConversations.widget) {
        window.HubSpotConversations.widget.open();
        return;
      }
      window.hsConversationsOnReady = [
        () => window.HubSpotConversations?.widget?.open?.(),
      ];
    } catch (e) {}
  };

  return (
    <section className="py-20 bg-gradient-to-br from-accent/5 via-background to-muted/20">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Left Content */}
            <div>
              <div className="inline-flex items-center space-x-2 bg-accent/10 text-accent-foreground px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Icon name="Calendar" size={16} />
                <span>Free Consultation</span>
              </div>

              <h2 className="text-fluid-4xl font-display font-bold text-primary mb-6">
                Ready to Bring Your
                <span className="text-accent"> Vision to Life?</span>
              </h2>

              <p className="text-fluid-lg text-muted-foreground mb-8 leading-relaxed">
                Let's discuss your project and explore how we can create
                something extraordinary together. Our consultation is completely
                free with no obligations.
              </p>

              {/* Benefits */}
              <div className="space-y-4 mb-8">
                {[
                  {
                    icon: "Clock",
                    title: "30-Minute Strategy Session",
                    description: "Deep dive into your vision and objectives",
                  },
                  {
                    icon: "Lightbulb",
                    title: "Creative Concept Development",
                    description: "Initial ideas and approach recommendations",
                  },
                  {
                    icon: "Calculator",
                    title: "Custom Pricing Proposal",
                    description: "Transparent pricing tailored to your budget",
                  },
                  {
                    icon: "Users",
                    title: "Meet Your Team",
                    description:
                      "Connect with the experts who'll handle your project",
                  },
                ]?.map((benefit, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Icon
                        name={benefit?.icon}
                        size={20}
                        className="text-accent"
                      />
                    </div>
                    <div>
                      <h4 className="font-semibold text-primary mb-1">
                        {benefit?.title}
                      </h4>
                      <p className="text-sm text-muted-foreground">
                        {benefit?.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Trust Indicators */}
              <div className="flex items-center space-x-6 text-sm text-muted-foreground">
                <div className="flex items-center space-x-2">
                  <Icon name="Shield" size={16} className="text-accent" />
                  <span>No Commitment Required</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Clock" size={16} className="text-accent" />
                  <span>24hr Response Time</span>
                </div>
              </div>
            </div>

            {/* Right: Embedded HubSpot Meetings (containerless) */}
            <div className="">
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-primary mb-2 font-display">
                  Book Your Free Consultation
                </h3>
                <p className="text-sm text-muted-foreground">
                  Pick a time that works best for you using our scheduler.
                </p>
              </div>

              {/* Inline meetings iframe */}
              <iframe
                title="HubSpot Meetings"
                src="https://meetings-na2.hubspot.com/brian-wilkinson?embed=true"
                style={{
                  width: "100%",
                  height: 660,
                  border: "none",
                  display: "block",
                }}
                scrolling="no"
                loading="lazy"
              />

              {/* Alternative Contact */}
              <div className="text-center pt-3 mt-3">
                <p className="text-sm text-muted-foreground mb-3">
                  Prefer to talk directly?
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Phone"
                    iconPosition="left"
                    asChild
                  >
                    <a href="tel:+15089805187">(508) 980-5187</a>
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="MessageCircle"
                    iconPosition="left"
                    onClick={openHubSpotChat}
                  >
                    Live Chat
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationCTA;
